import { render, staticRenderFns } from "./expressMessage.vue?vue&type=template&id=4f2d8e1a&scoped=true&"
import script from "./expressMessage.vue?vue&type=script&lang=js&"
export * from "./expressMessage.vue?vue&type=script&lang=js&"
import style0 from "./expressMessage.vue?vue&type=style&index=0&id=4f2d8e1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d8e1a",
  null
  
)

export default component.exports